import videoTrailer from '../../video-trailer/index.vue'
import CourseBladesButtons from '@/components/features/course-blades-buttons/index.vue'
import CourseBladesStatistic from '@/components/features/course-blades-statistic/index.vue'

export default {
    name: 'course-headers-with-sidebar',
    props: {
        item: {}
    },
    components: {
        videoTrailer,
        CourseBladesButtons,
        CourseBladesStatistic
    },
}
